// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3I6ZX","title":"ClientCherryInfo_title__2zBHm","itemText":"ClientCherryInfo_itemText__eE3-J"};